module.exports = require("./tk-TM.js");